<template>
  <label class="filtro-checkbox">
    <input
      type="checkbox"
      v-model="marcado"
      @change="aoAlterarCheckbox"
    />
    {{ $i18n('interface.novo_filtro.com_di_associada') }}
  </label>
</template>
<script>
export default {
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      marcado: false
    }
  },
  methods: {
    aoAlterarCheckbox() {
      if (this.marcado) {
        this.$aplicaFiltroEmURL('com_di_associada', '1', this.path);
        this.$store.commit('addFiltro', this.filtro);
        this.$store.commit('addFiltroAplicado', {
          filtro: 'com_di_associada',
          valor: '1'
        });
      } else {
        this.$removeFiltroDaURL('com_di_associada', this.path);
        this.$store.commit('removeFiltro', 'com_di_associada');
        this.$store.commit('removeFiltroAplicado', 'com_di_associada');
      }
    },
  },
  mounted() {
    this.marcado = this.$store.state.filtroAplicados['com_di_associada'] === '1';
  },
}
</script>
